import React from 'react'

const EmptyContainer = () => (
  <div className="container-empty" />
)

export default EmptyContainer
